import { loadedEnvelopeId } from './esign.state';

export function setLoadedEnvelopeId(envelopeId: number): void {
  loadedEnvelopeId.value = envelopeId;
}

